<div class="form-floating wrapper p-b-10"
[style.background]="isDisable?'#e9ecef' : 'transparent'"
[ngClass]="textareaClass"
[ngClass]="{'isDisable':isDisable}"
[style.height]="true?textareaHeight : '100%'"
[style.background]="isDisable?'#e9ecef' : 'transparent'">
  <textarea
    class="form-control resize"
    placeholder=""
    [name]="name"
    [id]="id"
    [disabled]="isDisable"
    [rows]="rows"
    [maxlength]="maxlength"
    [(ngModel)]="inputValue"
    (ngModelChange)="inputValueEmit.emit(inputValue)"
  ></textarea>
  <label [for]="id" class="label-truncate-md" [ngClass]="{'select_value':inputValue}">
   {{label}}<i *ngIf="isRequired" class="fst-normal ps-1 p-0 text-danger">*</i>
  </label>
  <span
    *ngIf="inputValue"
    (click)="isDisable?null:inputValueEmit.emit(undefined);isDisable?null:clearValue = true"
    class="position-absolute clear top-0 start-0 hand"
    ><app-svg-icon
      class="svgIcon"
      [src]="'../../../../../../../assets/SVGIcons/undoSVG.svg'"
    ></app-svg-icon
  ></span>
</div>
